import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { Swiper, SwiperSlide } from 'swiper/react';
import { EffectCoverflow, Pagination, Autoplay } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/effect-coverflow';
import 'swiper/css/pagination';

import "./style.css";

// Logo
import omniplayLogo from "../../assets/logo.png";

// Screenshots - servidas estaticamente de /public/screenshots/
// Cada item tem imagem e descrição para acessibilidade e SEO
const screenshotsList = [
  { image: "/screenshots/login.png", title: "Tela de Login", description: "Acesso seguro ao sistema com autenticação moderna" },
  { image: "/screenshots/dashboard.png", title: "Dashboard Principal", description: "Visão geral com métricas e indicadores em tempo real" },
  { image: "/screenshots/dashboard2.png", title: "Dashboard Avançado", description: "Gráficos detalhados de desempenho e produtividade" },
  { image: "/screenshots/atendimento.png", title: "Central de Atendimento", description: "Gerencie todos os seus tickets em um só lugar" },
  { image: "/screenshots/atendimento_completo.png", title: "Atendimento Completo", description: "Interface completa para atendimento multicanal" },
  { image: "/screenshots/chat_de_atendimento.png", title: "Chat de Atendimento", description: "Conversa em tempo real com recursos avançados" },
  { image: "/screenshots/chat_interno.png", title: "Chat Interno", description: "Comunicação entre equipes com salas e menções" },
  { image: "/screenshots/conexoes.png", title: "Conexões", description: "Gerencie WhatsApp, Telegram, Instagram e mais" },
  { image: "/screenshots/filas_setores.png", title: "Filas e Setores", description: "Organize atendimentos por departamento" },
  { image: "/screenshots/criar_atendentes.png", title: "Gestão de Atendentes", description: "Cadastre e gerencie sua equipe de atendimento" },
  { image: "/screenshots/permissoes_de_acesso.png", title: "Permissões de Acesso", description: "Controle granular de acesso por perfil" },
  { image: "/screenshots/edicao_usuario_e_ramal_voip.png", title: "Edição de Usuário e VoIP", description: "Configure ramais e preferências por atendente" },
  { image: "/screenshots/gestao_de_contatos.png", title: "Gestão de Contatos", description: "Base de clientes centralizada com tags e campos" },
  { image: "/screenshots/flowbuilder_visual.png", title: "FlowBuilder Visual", description: "Crie fluxos de atendimento arrastando e soltando" },
  { image: "/screenshots/integracoes_n8n_typebot.png", title: "Integrações N8N e Typebot", description: "Conecte com automações externas e chatbots" },
  { image: "/screenshots/integracao_ifood.png", title: "Integração iFood", description: "Receba pedidos do iFood diretamente no chat" },
  { image: "/screenshots/templates_waba.png", title: "Templates WhatsApp API", description: "Gerencie templates aprovados pela Meta" },
  { image: "/screenshots/mensagens_rapidas.png", title: "Mensagens Rápidas", description: "Atalhos para respostas frequentes" },
  { image: "/screenshots/agendamento_mensagens.png", title: "Agendamento de Mensagens", description: "Programe envios para horários específicos" },
  { image: "/screenshots/agendamento_de_mensagem.png", title: "Detalhes do Agendamento", description: "Configure data, hora e destinatários" },
  { image: "/screenshots/talk_ai.png", title: "Talk.AI - Copiloto IA", description: "Sugestões inteligentes e análise de sentimento" },
  { image: "/screenshots/resumo_ai.png", title: "Resumo com IA", description: "Sumarização automática de conversas longas" },
  { image: "/screenshots/transcricao_speech_to_text.png", title: "Transcrição de Áudio", description: "Converta áudios em texto automaticamente" },
  { image: "/screenshots/logs_ticket.png", title: "Logs de Ticket", description: "Histórico completo de ações no atendimento" },
  { image: "/screenshots/auditoria.png", title: "Auditoria do Sistema", description: "Rastreie todas as ações dos usuários" },
  { image: "/screenshots/backup.png", title: "Backup e Restauração", description: "Proteja seus dados com backups automáticos" },
  { image: "/screenshots/armazenamento.png", title: "Armazenamento", description: "Monitore uso de espaço e arquivos" },
  { image: "/screenshots/google_calendar.png", title: "Google Calendar", description: "Sincronize agendamentos com sua agenda" },
  { image: "/screenshots/feriados.png", title: "Gestão de Feriados", description: "Configure feriados e horários especiais" },
  { image: "/screenshots/modo_pausa_do_atendente.png", title: "Modo Pausa", description: "Atendentes podem pausar com mensagem automática" },
  { image: "/screenshots/softphone_voip.png", title: "Softphone VoIP", description: "Faça ligações diretamente pelo sistema" },
  { image: "/screenshots/meuplano.png", title: "Meu Plano", description: "Gerencie sua assinatura e recursos" },
  { image: "/screenshots/opcoes.png", title: "Opções do Sistema", description: "Personalize comportamentos e preferências" },
  { image: "/screenshots/desktop.png", title: "Versão Desktop", description: "Interface otimizada para computadores" },
  { image: "/screenshots/mobile.png", title: "Versão Mobile", description: "Atenda de qualquer lugar pelo celular" },
];

// Ícones SVG inline
const Icons = {
  Zap: () => (
    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/>
    </svg>
  ),
  ArrowRight: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/>
    </svg>
  ),
  Check: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="20 6 9 17 4 12"/>
    </svg>
  ),
  Menu: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="18" x2="21" y2="18"/>
    </svg>
  ),
  X: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
    </svg>
  ),
  Globe: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10"/><line x1="2" y1="12" x2="22" y2="12"/><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/>
    </svg>
  ),
  Users: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/>
    </svg>
  ),
  MessageSquare: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
    </svg>
  ),
  Headphones: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M3 18v-6a9 9 0 0 1 18 0v6"/><path d="M21 19a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3zM3 19a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2H3z"/>
    </svg>
  ),
  Building2: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M6 22V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v18Z"/><path d="M6 12H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2"/><path d="M18 9h2a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2h-2"/><path d="M10 6h4"/><path d="M10 10h4"/><path d="M10 14h4"/><path d="M10 18h4"/>
    </svg>
  ),
  BarChart3: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M3 3v18h18"/><path d="M18 17V9"/><path d="M13 17V5"/><path d="M8 17v-3"/>
    </svg>
  ),
  Shield: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
    </svg>
  ),
  Play: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <polygon points="5 3 19 12 5 21 5 3"/>
    </svg>
  ),
  Clock: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/>
    </svg>
  ),
  Calculator: () => (
    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="4" y="2" width="16" height="20" rx="2"/><line x1="8" y1="6" x2="16" y2="6"/><line x1="16" y1="14" x2="16" y2="18"/><line x1="8" y1="14" x2="8" y2="18"/><line x1="12" y1="14" x2="12" y2="18"/>
    </svg>
  ),
  TrendingUp: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="23 6 13.5 15.5 8.5 10.5 1 18"/><polyline points="17 6 23 6 23 12"/>
    </svg>
  ),
  Timer: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <line x1="10" y1="2" x2="14" y2="2"/><line x1="12" y1="14" x2="12" y2="8"/><circle cx="12" cy="14" r="8"/>
    </svg>
  ),
  Percent: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <line x1="19" y1="5" x2="5" y2="19"/><circle cx="6.5" cy="6.5" r="2.5"/><circle cx="17.5" cy="17.5" r="2.5"/>
    </svg>
  ),
  Mail: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/>
    </svg>
  ),
  Phone: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>
    </svg>
  ),
  Send: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/>
    </svg>
  ),
  ChevronDown: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="6 9 12 15 18 9"/>
    </svg>
  ),
  ChevronLeft: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="15 18 9 12 15 6"/>
    </svg>
  ),
  ChevronRight: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="9 18 15 12 9 6"/>
    </svg>
  ),
  WhatsApp: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
      <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
    </svg>
  ),
  Telegram: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
      <path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z"/>
    </svg>
  ),
  Facebook: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
      <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
    </svg>
  ),
  InstagramIcon: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
      <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
    </svg>
  ),
  EmailIcon: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/>
    </svg>
  ),
  Webchat: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
    </svg>
  ),
  Robot: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="11" width="18" height="10" rx="2"/><circle cx="12" cy="5" r="2"/><path d="M12 7v4"/><line x1="8" y1="16" x2="8" y2="16"/><line x1="16" y1="16" x2="16" y2="16"/>
    </svg>
  ),
  Sparkles: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="m12 3-1.912 5.813a2 2 0 0 1-1.275 1.275L3 12l5.813 1.912a2 2 0 0 1 1.275 1.275L12 21l1.912-5.813a2 2 0 0 1 1.275-1.275L21 12l-5.813-1.912a2 2 0 0 1-1.275-1.275L12 3Z"/><path d="M5 3v4"/><path d="M19 17v4"/><path d="M3 5h4"/><path d="M17 19h4"/>
    </svg>
  ),
};

// Traduções em Português
const t = {
  nav: {
    features: "Recursos",
    pricing: "Preços",
    faq: "FAQ",
    contact: "Contato",
    login: "Entrar",
    getStarted: "Começar",
  },
  hero: {
    badge: "Plataforma Omnichannel com IA",
    title: "Atendimento Omnichannel",
    titleHighlight: "com Inteligência Artificial",
    subtitle: "Unifique WhatsApp, Telegram, Instagram, Facebook, Email e Webchat em uma única plataforma. Potencialize seu atendimento com o copiloto Talk.AI.",
    startTrial: "Iniciar Teste Grátis",
    viewPricing: "Ver Preços",
    noCreditCard: "Sem cartão de crédito",
    freeTrial: "7 dias grátis",
    cancelAnytime: "Cancele quando quiser",
  },
  valueProps: {
    title: "Construído para Escala Empresarial",
    subtitle: "Tudo o que você precisa para operar atendimento multicanal com IA",
    omnichannel: {
      title: "7 Canais Integrados",
      description: "WhatsApp (API e QR-Code), Telegram, Instagram, Facebook, Email e Webchat. Todos centralizados em uma única plataforma.",
    },
    unlimitedAttendants: {
      title: "Atendentes Ilimitados",
      description: "Escale sua equipe de suporte sem restrições. Adicione quantos agentes precisar com controle de acesso baseado em funções.",
    },
    officialApi: {
      title: "Copiloto Talk.AI",
      description: "Inteligência artificial que sugere respostas, resume conversas e auxilia seus atendentes em tempo real.",
    },
  },
  channels: {
    title: "Todos os Canais em Um Só Lugar",
    subtitle: "Conecte-se com seus clientes onde eles estiverem. Suporte completo aos principais canais de comunicação.",
  },
  talkAI: {
    title: "Conheça o Talk.AI",
    subtitle: "Seu copiloto de atendimento com inteligência artificial",
    description: "O Talk.AI é o assistente inteligente que revoluciona o atendimento da sua equipe. IA de ponta para produtividade, acessibilidade e automação avançada.",
    features: [
      { text: "Agentes Autônomos", highlight: true, description: "Atendimento 100% autônomo com IA" },
      { text: "Classificadores de Intenção", highlight: true, description: "Roteamento inteligente por IA" },
      { text: "Orquestrador de IA", highlight: false, description: "Gerencie múltiplos agentes facilmente" },
      { text: "Sugestões Inteligentes", highlight: false, description: "Respostas contextuais em tempo real" },
      { text: "Transcrição de Áudio", highlight: false, description: "Áudio vira texto instantaneamente" },
      { text: "Texto para Voz (TTS)", highlight: false, description: "Inclusão e acessibilidade" },
    ]
  },
  features: {
    title: "Recursos Poderosos para Cada Equipe",
    subtitle: "Tudo o que você precisa para gerenciar comunicações omnichannel em escala",
    attendantDashboard: {
      title: "7 Canais de Atendimento",
      description: "Conecte-se com seus clientes através de todos os canais populares em uma única plataforma.",
      bullets: ["WhatsApp API Oficial", "WhatsApp por QR-Code", "Telegram", "Instagram Direct", "Facebook Messenger", "Email (IMAP/SMTP)", "Webchat"],
    },
    tenantManagement: {
      title: "FlowBuilder e Automações",
      description: "Crie fluxos de atendimento automatizados com nosso construtor visual intuitivo e integrações poderosas.",
      bullets: ["FlowBuilder visual", "Integração com N8N", "Integração com Typebot", "Automações personalizadas"],
    },
    analytics: {
      title: "Inteligência Artificial Nativa",
      description: "Agentes Autônomos, Orquestradores, Classificadores de Intenção e Copiloto em tempo real para sua equipe.",
      bullets: ["Agentes Autônomos", "Classificadores de Intenção", "Orquestradores de IA", "Talk.AI Copiloto"],
    },
    security: {
      title: "Comunicação Interna",
      description: "Ferramentas exclusivas para sua equipe se comunicar e colaborar em tempo real.",
      bullets: ["Softphone VoIP integrado", "Chat interno da equipe", "Chamadas via WebRTC", "Transferência de chamadas"],
    },
  },
  extras: {
    title: "Funcionalidades Exclusivas",
    subtitle: "Recursos que só o OmniPlay oferece",
    softphone: {
      title: "Softphone VoIP",
      description: "Faça e receba chamadas telefônicas diretamente pelo navegador. Integração completa com seu PABX via SIP/WebRTC.",
      features: ["Chamadas de entrada e saída", "Identificação de chamadas", "Gravação de chamadas", "Transferência entre atendentes", "Histórico completo"]
    },
    chatInternal: {
      title: "Chat Interno",
      description: "Comunicação instantânea entre sua equipe. Crie salas, grupos e converse em tempo real sem sair da plataforma.",
      features: ["Salas públicas e privadas", "Mensagens em tempo real", "Compartilhamento de arquivos", "Menções e notificações", "Histórico persistente"]
    },
    googleDrive: {
      title: "Integração Google Drive",
      description: "Espelhamento automático e backup das suas mídias diretamente para o Google Drive para economizar storage.",
      features: ["Backup em Nuvem", "Espelhamento Automático", "Economia de Storage", "Segurança de Dados", "Ciclo de Retenção"]
    }
  },
  screenshots: {
    title: "Veja o OmniPlay por Dentro",
    subtitle: "Navegue pelas telas do sistema e conheça nossos principais recursos.",
  },
  pricing: {
    title: "Planos Simples e Transparentes",
    subtitle: "Escolha o plano perfeito para o tamanho da sua equipe. Todos os planos incluem API oficial do WhatsApp e suporte dedicado.",
    popular: "Popular",
    perMonth: "/mês",
    getStarted: "Começar",
    contactSales: "Falar com Vendas",
  },
  faq: {
    title: "Perguntas Frequentes",
    subtitle: "Tudo o que você precisa saber sobre o OmniPlay",
    categories: [
      {
        name: "🌐 Canais e Integrações",
        items: [
          {
            question: "Quais canais de comunicação são suportados?",
            answer: "O OmniPlay suporta 7 canais: WhatsApp (API oficial e QR-Code), Telegram, Instagram Direct, Facebook Messenger, Email (IMAP/SMTP) e Webchat. Todos centralizados em uma única plataforma.",
          },
          {
            question: "Qual a diferença entre WhatsApp API e WhatsApp QR-Code?",
            answer: "O WhatsApp API é a solução oficial da Meta, oferece selo verificado, maior estabilidade e recursos empresariais. O WhatsApp QR-Code permite conexão rápida sem aprovação da Meta, ideal para começar rapidamente ou para múltiplos números.",
          },
          {
            question: "Posso usar Instagram e Facebook ao mesmo tempo?",
            answer: "Sim! Você pode conectar quantas páginas do Facebook e contas do Instagram desejar, todas centralizadas no mesmo painel de atendimento.",
          },
          {
            question: "Como funciona o canal de Email?",
            answer: "O OmniPlay se conecta a qualquer servidor de email via IMAP/SMTP. Seus emails chegam como tickets normais, permitindo responder diretamente pela plataforma mantendo todo o histórico.",
          },
          {
            question: "O Webchat pode ser customizado?",
            answer: "Sim! O widget de Webchat pode ser totalmente personalizado com as cores da sua marca, logo, mensagem de boas-vindas e campos de captura de dados do visitante.",
          },
        ]
      },
      {
        name: "🤖 Talk.AI - Inteligência Artificial",
        items: [
          {
            question: "O que é o Talk.AI?",
            answer: "O Talk.AI é nosso copiloto de atendimento com inteligência artificial. Ele sugere respostas em tempo real, transcreve áudios, converte texto em voz (TTS), resume conversas longas e analisa o sentimento do cliente.",
          },
          {
            question: "Como funciona o Texto para Voz (TTS)?",
            answer: "O recurso TTS permite que mensagens de texto sejam convertidas em áudio, promovendo acessibilidade e inclusão para pessoas com deficiência visual ou dificuldades de leitura.",
          },
          {
            question: "O Talk.AI transcreve áudios automaticamente?",
            answer: "Sim! Todos os áudios recebidos são transcritos automaticamente para texto, facilitando a leitura rápida e busca posterior nas conversas.",
          },
          {
            question: "A IA sugere respostas automaticamente?",
            answer: "Sim! O Talk.AI analisa o contexto da conversa e sugere respostas relevantes que o atendente pode usar com um clique, agilizando o atendimento.",
          },
          {
            question: "O que é análise de sentimento?",
            answer: "O Talk.AI identifica se o cliente está satisfeito, neutro ou insatisfeito, ajudando o atendente a adaptar sua abordagem e priorizar casos críticos.",
          },
        ]
      },
      {
        name: "📞 Softphone e Chat Interno",
        items: [
          {
            question: "O que é o Softphone VoIP?",
            answer: "É um telefone virtual integrado ao OmniPlay. Você pode fazer e receber chamadas diretamente pelo navegador, sem precisar de aparelho físico. Funciona via SIP/WebRTC com qualquer PABX.",
          },
          {
            question: "Preciso de equipamento especial para usar o Softphone?",
            answer: "Não! Basta um computador com microfone e fone de ouvido. O Softphone funciona diretamente no navegador via WebRTC.",
          },
          {
            question: "As chamadas são gravadas?",
            answer: "Sim, se habilitado. Todas as chamadas podem ser gravadas automaticamente e ficam disponíveis no histórico do contato para consulta posterior.",
          },
          {
            question: "O que é o Chat Interno?",
            answer: "É um sistema de mensagens instantâneas para comunicação entre sua equipe. Crie salas públicas ou privadas, compartilhe arquivos e mantenha todos alinhados sem sair da plataforma.",
          },
          {
            question: "Posso criar grupos no Chat Interno?",
            answer: "Sim! Você pode criar salas para departamentos, projetos ou equipes específicas. Administradores e supervisores podem gerenciar participantes e permissões.",
          },
        ]
      },
      {
        name: "⚙️ Automação e Fluxos",
        items: [
          {
            question: "O que é o FlowBuilder?",
            answer: "É nosso construtor visual de fluxos de atendimento. Crie chatbots, menus interativos e automações arrastando e conectando blocos, sem precisar programar.",
          },
          {
            question: "Posso integrar com N8N ou Typebot?",
            answer: "Sim! O OmniPlay possui integração nativa com N8N e Typebot, permitindo criar automações complexas e fluxos conversacionais avançados.",
          },
          {
            question: "É possível agendar mensagens?",
            answer: "Sim! Você pode agendar mensagens para serem enviadas em data e hora específicas, com opção de recorrência (diária, semanal, mensal).",
          },
          {
            question: "Como funcionam as respostas rápidas?",
            answer: "Você pode criar atalhos para mensagens frequentes. Basta digitar o atalho e a mensagem completa é inserida automaticamente, agilizando o atendimento.",
          },
        ]
      },
      {
        name: "💼 Planos e Suporte",
        items: [
          {
            question: "Quantos atendentes posso ter?",
            answer: "Depende do seu plano. O Iniciante suporta até 3 atendentes, o Profissional suporta até 10, e o Ultra oferece atendentes ilimitados.",
          },
          {
            question: "Existe um período de teste gratuito?",
            answer: "Sim, oferecemos um teste gratuito de 7 dias em todos os planos. Não é necessário cartão de crédito para começar.",
          },
          {
            question: "Posso migrar meu número WhatsApp existente?",
            answer: "Sim, você pode migrar seus números WhatsApp Business existentes para o OmniPlay. Nossa equipe ajudará durante o processo de migração.",
          },
          {
            question: "Que tipo de suporte vocês oferecem?",
            answer: "Todos os planos incluem suporte por email e WhatsApp. Os planos Profissional e Ultra incluem suporte prioritário com tempos de resposta mais rápidos e atendimento personalizado.",
          },
          {
            question: "Meus dados estão seguros?",
            answer: "Sim! Utilizamos criptografia em todas as comunicações, backups automáticos e infraestrutura em nuvem com alta disponibilidade. Estamos em conformidade com a LGPD.",
          },
          {
            question: "Posso cancelar a qualquer momento?",
            answer: "Sim, não há fidelidade. Você pode cancelar seu plano a qualquer momento sem multas ou taxas adicionais.",
          },
        ]
      },
    ],
  },
  contact: {
    title: "Vamos Conversar",
    subtitle: "Pronto para transformar a comunicação do seu negócio? Entre em contato com nossa equipe de vendas.",
    info: {
      phone: "+55 (18) 3621-5152",
      email: "saas@netplay.net.br",
      address: "Araçatuba, SP, Brasil",
      hours: "Seg-Sex: 9h - 18h",
      emailLabel: "Email",
      phoneLabel: "Telefone",
    },
    form: {
      name: "Seu Nome",
      email: "Seu Email",
      company: "Nome da Empresa",
      message: "Conte-nos sobre suas necessidades...",
      submit: "Enviar Mensagem",
      sending: "Enviando...",
    },
    social: "Siga-nos",
  },
  footer: {
    description: "A plataforma WhatsApp Business API para equipes que querem escalar.",
    product: "Produto",
    legal: "Legal",
    links: {
      features: "Recursos",
      pricing: "Preços",
      privacy: "Política de Privacidade",
      terms: "Termos de Serviço",
    },
    copyright: "Todos os direitos reservados.",
  },
};

// Navigation Component
function Navigation({ isScrolled, isMobileMenuOpen, setIsMobileMenuOpen, scrollToSection, history }) {
  return (
    <nav className={`landing-nav ${isScrolled ? "scrolled" : ""}`}>
      <div className="landing-nav-container">
        <div className="landing-nav-content">
          <div className="landing-nav-logo">
            <img src={omniplayLogo} alt="OmniPlay" />
          </div>

          <div className="landing-nav-links">
            <button onClick={() => scrollToSection("features")}>{t.nav.features}</button>
            <button onClick={() => scrollToSection("pricing")}>{t.nav.pricing}</button>
            <button onClick={() => scrollToSection("faq")}>{t.nav.faq}</button>
            <button onClick={() => scrollToSection("contact")}>{t.nav.contact}</button>
          </div>

          <div className="landing-nav-actions">
            <button className="landing-btn-ghost" onClick={() => history.push("/login")}>
              {t.nav.login}
            </button>
            <button className="landing-btn-primary" onClick={() => history.push("/pricing")}>
              {t.nav.getStarted}
              <Icons.ArrowRight />
            </button>
          </div>

          <button className="landing-nav-mobile-toggle" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}>
            {isMobileMenuOpen ? <Icons.X /> : <Icons.Menu />}
          </button>
        </div>
      </div>

      {isMobileMenuOpen && (
        <div className="landing-nav-mobile-menu">
          <button onClick={() => { scrollToSection("features"); setIsMobileMenuOpen(false); }}>{t.nav.features}</button>
          <button onClick={() => { scrollToSection("pricing"); setIsMobileMenuOpen(false); }}>{t.nav.pricing}</button>
          <button onClick={() => { scrollToSection("faq"); setIsMobileMenuOpen(false); }}>{t.nav.faq}</button>
          <button onClick={() => { scrollToSection("contact"); setIsMobileMenuOpen(false); }}>{t.nav.contact}</button>
          <div className="landing-nav-mobile-actions">
            <button className="landing-btn-outline full-width" onClick={() => history.push("/login")}>
              {t.nav.login}
            </button>
            <button className="landing-btn-primary full-width" onClick={() => history.push("/pricing")}>
              {t.nav.getStarted}
            </button>
          </div>
        </div>
      )}
    </nav>
  );
}

// Hero Section
function HeroSection({ scrollToSection, history }) {
  return (
    <section className="landing-hero">
      <div className="landing-hero-bg">
        <div className="landing-hero-blob blob-1" />
        <div className="landing-hero-blob blob-2" />
      </div>
      <div className="landing-hero-content">
        <div className="landing-hero-badge">
          <Icons.Zap />
          {t.hero.badge}
        </div>
        <h1>
          {t.hero.title} <span className="text-primary">{t.hero.titleHighlight}</span>
        </h1>
        <p>{t.hero.subtitle}</p>
        <div className="landing-hero-buttons">
          <button className="landing-btn-primary large" onClick={() => history.push("/pricing")}>
            {t.hero.startTrial}
            <Icons.ArrowRight />
          </button>
          <button className="landing-btn-outline large" onClick={() => history.push("/pricing")}>
            {t.hero.viewPricing}
          </button>
        </div>
        <div className="landing-hero-features">
          <div className="landing-hero-feature">
            <Icons.Check />
            <span>{t.hero.noCreditCard}</span>
          </div>
          <div className="landing-hero-feature">
            <Icons.Check />
            <span>{t.hero.freeTrial}</span>
          </div>
          <div className="landing-hero-feature">
            <Icons.Check />
            <span>{t.hero.cancelAnytime}</span>
          </div>
        </div>
      </div>
    </section>
  );
}

// Value Props Section
function ValuePropsSection() {
  const props = [
    { icon: Icons.Globe, ...t.valueProps.omnichannel },
    { icon: Icons.Users, ...t.valueProps.unlimitedAttendants },
    { icon: Icons.MessageSquare, ...t.valueProps.officialApi },
  ];

  return (
    <section className="landing-section" id="features">
      <div className="landing-container">
        <div className="landing-section-header">
          <h2>{t.valueProps.title}</h2>
          <p>{t.valueProps.subtitle}</p>
        </div>
        <div className="landing-value-props-grid">
          {props.map((prop, index) => (
            <div key={index} className="landing-card">
              <div className="landing-card-icon">
                <prop.icon />
              </div>
              <h3>{prop.title}</h3>
              <p>{prop.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

// Channels Section - Grid responsivo de 7 canais
function ChannelsSection() {
  const [isMobile, setIsMobile] = React.useState(window.innerWidth <= 768);
  
  React.useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const channels = [
    { icon: Icons.WhatsApp, name: "WhatsApp API", description: "API Oficial Meta", color: "#25D366", badge: "Principal" },
    { icon: Icons.WhatsApp, name: "WhatsApp QR", description: "Via QR-Code", color: "#128C7E" },
    { icon: Icons.Telegram, name: "Telegram", description: "Bots e grupos", color: "#0088cc" },
    { icon: Icons.InstagramIcon, name: "Instagram", description: "Direct Messages", color: "#E1306C" },
    { icon: Icons.Facebook, name: "Facebook", description: "Messenger", color: "#1877F2" },
    { icon: Icons.EmailIcon, name: "Email", description: "IMAP/SMTP", color: "#EA4335" },
    { icon: Icons.Webchat, name: "Webchat", description: "Widget p/ site", color: "#0EA5E9" },
  ];

  const ChannelCard = ({ channel, featured = false }) => (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        padding: isMobile ? "16px 12px" : "20px 16px",
        background: "#fff",
        borderRadius: "16px",
        boxShadow: featured 
          ? `0 8px 32px ${channel.color}25` 
          : "0 4px 16px rgba(0,0,0,0.06)",
        transition: "all 0.3s ease",
        cursor: "default",
        border: featured ? `2px solid ${channel.color}` : "2px solid transparent",
        position: "relative",
        minHeight: isMobile ? "120px" : "140px",
      }}
      onMouseEnter={(e) => {
        if (!isMobile) {
          e.currentTarget.style.transform = "translateY(-4px)";
        e.currentTarget.style.borderColor = channel.color;
          e.currentTarget.style.boxShadow = `0 12px 32px ${channel.color}30`;
        }
      }}
      onMouseLeave={(e) => {
        if (!isMobile) {
          e.currentTarget.style.transform = "translateY(0)";
          e.currentTarget.style.borderColor = featured ? channel.color : "transparent";
          e.currentTarget.style.boxShadow = featured 
            ? `0 8px 32px ${channel.color}25` 
            : "0 4px 16px rgba(0,0,0,0.06)";
        }
      }}
    >
      {channel.badge && (
        <span style={{
          position: "absolute",
          top: "-10px",
          right: isMobile ? "-4px" : "-8px",
          background: "linear-gradient(135deg, #10b981 0%, #059669 100%)",
          color: "#fff",
          fontSize: "0.65rem",
          fontWeight: 700,
          padding: "3px 8px",
          borderRadius: "20px",
          textTransform: "uppercase",
          letterSpacing: "0.5px",
          boxShadow: "0 2px 8px rgba(16,185,129,0.4)",
        }}>
          {channel.badge}
        </span>
      )}
      <div style={{
        width: isMobile ? "44px" : "52px",
        height: isMobile ? "44px" : "52px",
        borderRadius: "50%",
        background: `${channel.color}12`,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        marginBottom: "10px",
        color: channel.color,
      }}>
        <channel.icon style={{ fontSize: isMobile ? "22px" : "26px" }} />
      </div>
      <h4 style={{ 
        fontSize: isMobile ? "0.85rem" : "0.95rem", 
        fontWeight: 600, 
        marginBottom: "4px", 
        color: "#1f2937",
        textAlign: "center",
        lineHeight: 1.2,
      }}>
        {channel.name}
      </h4>
      <p style={{ 
        fontSize: isMobile ? "0.7rem" : "0.75rem", 
        color: "#6b7280", 
        textAlign: "center", 
        margin: 0, 
        lineHeight: 1.3,
      }}>
        {channel.description}
      </p>
    </div>
  );

  return (
    <section className="landing-section" style={{ background: "linear-gradient(135deg, #fbfbf9 0%, #f4f2f0 50%, #fbfbf9 100%)" }}>
      <div className="landing-container">
        <div className="landing-section-header">
          <h2>{t.channels.title}</h2>
          <p>{t.channels.subtitle}</p>
        </div>
        
        {/* Grid Responsivo - 2 colunas mobile, flexível desktop */}
        <div style={{
          display: "grid",
          gridTemplateColumns: isMobile 
            ? "repeat(2, 1fr)" 
            : "repeat(auto-fit, minmax(140px, 1fr))",
          gap: isMobile ? "12px" : "16px",
          maxWidth: "900px",
          margin: "0 auto",
          padding: isMobile ? "0 8px" : "0",
        }}>
          {channels.map((channel, index) => (
            <ChannelCard 
              key={index} 
              channel={channel} 
              featured={index === 0}
            />
          ))}
        </div>
      </div>
    </section>
  );
}

// Talk.AI Section - Destaque do copiloto com ênfase em inclusão
function TalkAISection() {
  return (
    <section className="landing-section" style={{ 
      background: "#000000",
      color: "#fff",
      position: "relative",
      overflow: "hidden",
      padding: "100px 0",
      borderTop: "1px solid rgba(255,255,255,0.05)"
    }}>
      {/* Background decorativo */}
      <div style={{
        position: "absolute",
        top: "0%",
        right: "0%",
        width: "800px",
        height: "800px",
        background: "radial-gradient(circle at center, rgba(0, 112, 243, 0.08) 0%, transparent 70%)",
        borderRadius: "50%",
        pointerEvents: "none"
      }} />
      <div style={{
        position: "absolute",
        bottom: "-20%",
        left: "-10%",
        width: "600px",
        height: "600px",
        background: "radial-gradient(circle at center, rgba(255, 255, 255, 0.03) 0%, transparent 70%)",
        borderRadius: "50%",
        pointerEvents: "none"
      }} />
      
      <div className="landing-container" style={{ position: "relative", zIndex: 1 }}>
        {/* Header centralizado */}
        <div style={{ textAlign: "center", marginBottom: "64px" }}>
          <div style={{
            display: "inline-flex",
            alignItems: "center",
            gap: "8px",
            background: "rgba(255,255,255,0.05)",
            border: "1px solid rgba(255,255,255,0.1)",
            padding: "8px 16px",
            borderRadius: "6px",
            marginBottom: "24px",
          }}>
            <Icons.Sparkles />
            <span style={{ fontSize: "0.875rem", fontWeight: 500, letterSpacing: "0.02em" }}>Inteligência Artificial</span>
          </div>
          
          <h2 style={{ 
            fontSize: "3.5rem", 
            fontWeight: 800, 
            letterSpacing: "-0.04em",
            marginBottom: "20px",
            lineHeight: 1.1,
            color: "#fff"
          }}>
            {t.talkAI.title}
          </h2>
          <p style={{ 
            fontSize: "1.125rem", 
            color: "#A1A1AA", 
            maxWidth: "600px",
            margin: "0 auto",
            lineHeight: 1.6 
          }}>
            {t.talkAI.description}
          </p>
        </div>

        {/* Cards de Features em destaque */}
        <div style={{
          display: "grid",
          gridTemplateColumns: "repeat(3, 1fr)",
          gap: "24px",
          maxWidth: "1000px",
          margin: "0 auto",
        }} className="talk-ai-features-grid">
          {t.talkAI.features.map((feature, index) => (
            <div 
              key={index} 
              style={{
                position: "relative",
                padding: "24px",
                background: feature.highlight 
                  ? "rgba(255,255,255,0.05)"
                  : "rgba(0,0,0,0.4)",
                borderRadius: "12px",
                border: feature.highlight 
                  ? "1px solid rgba(255,255,255,0.2)" 
                  : "1px solid rgba(255,255,255,0.05)",
                transition: "all 0.2s ease",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-2px)";
                e.currentTarget.style.borderColor = "rgba(255,255,255,0.3)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.borderColor = feature.highlight 
                  ? "rgba(255,255,255,0.2)" 
                  : "rgba(255,255,255,0.05)";
              }}
            >
              {/* Badge de destaque */}
              {feature.highlight && (
                <div style={{
                  position: "absolute",
                  top: "16px",
                  right: "16px",
                  background: "#FFFFFF",
                  color: "#000000",
                  fontSize: "0.65rem",
                  fontWeight: 700,
                  padding: "4px 8px",
                  borderRadius: "4px",
                  textTransform: "uppercase",
                  letterSpacing: "0.05em",
                }}>
                  Top
                </div>
              )}
              
              <div style={{
                display: "flex",
                alignItems: "center",
                gap: "12px",
                marginBottom: "10px",
              }}>
                <div style={{
                  width: "36px",
                  height: "36px",
                  borderRadius: "10px",
                  background: feature.highlight 
                    ? "linear-gradient(135deg, #ff8ba1 0%, #ff609a 100%)"
                    : "rgba(255,255,255,0.15)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexShrink: 0,
                }}>
                  <Icons.Check />
                </div>
                <span style={{ 
                  fontSize: feature.highlight ? "1.1rem" : "1rem", 
                  fontWeight: feature.highlight ? 700 : 600,
                }}>
                  {feature.text}
                </span>
              </div>
              
              <p style={{ 
                fontSize: "0.85rem", 
                opacity: 0.8, 
                margin: 0,
                paddingLeft: "48px",
                lineHeight: 1.5,
              }}>
                {feature.description}
              </p>
            </div>
          ))}
        </div>

        {/* Mensagem de inclusão */}
        <div style={{
          textAlign: "center",
          marginTop: "48px",
          padding: "24px",
          background: "rgba(255,212,68,0.15)", /* yellow */
          borderRadius: "16px",
          border: "1px solid rgba(255,212,68,0.3)",
          maxWidth: "700px",
          margin: "48px auto 0",
        }}>
          <div style={{ fontSize: "1.5rem", marginBottom: "8px" }}>♿ 🔊 👁️</div>
          <p style={{ 
            fontSize: "1rem", 
            fontWeight: 600, 
            marginBottom: "4px",
            color: "#f5d444" 
          }}>
            Comprometidos com Acessibilidade e Inclusão
          </p>
          <p style={{ 
            fontSize: "0.9rem", 
            opacity: 0.85, 
            margin: 0 
          }}>
            Texto para voz e transcrição de áudio permitem que pessoas com deficiência visual ou auditiva 
            participem plenamente do atendimento ao cliente.
          </p>
        </div>
      </div>
      
      <style>{`
        @keyframes pulse {
          0%, 100% { transform: scale(1); }
          50% { transform: scale(1.05); }
        }
        @media (max-width: 900px) {
          .talk-ai-features-grid {
            grid-template-columns: repeat(2, 1fr) !important;
          }
        }
        @media (max-width: 600px) {
          .talk-ai-features-grid {
            grid-template-columns: 1fr !important;
          }
        }
      `}</style>
    </section>
  );
}

// Features Showcase Section
function FeaturesShowcase() {
  const features = [
    { 
      icon: Icons.Headphones, 
      color: "#865ceb", // Purple
      gradient: "linear-gradient(135deg, #9f82ec, #865ceb)",
      bgLight: "rgba(134, 92, 235, 0.1)",
      ...t.features.attendantDashboard 
    },
    { 
      icon: Icons.Building2, 
      color: "#ff9b17", // Orange
      gradient: "linear-gradient(135deg, #ff9b17, #f77c02)",
      bgLight: "rgba(255, 155, 23, 0.1)",
      ...t.features.tenantManagement 
    },
    { 
      icon: Icons.Sparkles, 
      color: "#ff609a", // Pink
      gradient: "linear-gradient(135deg, #ff8ba1, #ff609a)",
      bgLight: "rgba(255, 96, 154, 0.1)",
      ...t.features.analytics 
    },
    { 
      icon: Icons.BarChart3, 
      color: "#f5d444", // Yellow
      gradient: "linear-gradient(135deg, #fced95, #f5d444)",
      bgLight: "rgba(245, 212, 68, 0.1)",
      ...t.features.security 
    },
  ];

  return (
    <section className="landing-section" style={{ 
      background: "linear-gradient(180deg, #fdfdfc 0%, #ffffff 50%, #fdfdfc 100%)",
      padding: "100px 0",
    }}>
      <div className="landing-container">
        <div className="landing-section-header" style={{ marginBottom: "60px" }}>
          <div style={{
            display: "inline-flex",
            alignItems: "center",
            gap: "8px",
            background: "linear-gradient(135deg, rgba(134,92,235,0.1) 0%, rgba(255,155,23,0.1) 100%)",
            padding: "8px 16px",
            borderRadius: "100px",
            marginBottom: "16px",
          }}>
            <Icons.Zap />
            <span style={{ fontSize: "0.875rem", fontWeight: 600, color: "#865ceb" }}>Recursos Completos</span>
          </div>
          <h2>{t.features.title}</h2>
          <p>{t.features.subtitle}</p>
        </div>

        {/* Grid de Features 2x2 */}
        <div style={{
          display: "grid",
          gridTemplateColumns: "repeat(2, 1fr)",
          gap: "24px",
          maxWidth: "1100px",
          margin: "0 auto",
        }} className="features-grid">
          {features.map((feature, index) => (
            <div 
              key={index} 
              style={{
                background: "#fff",
                borderRadius: "20px",
                padding: "32px",
                boxShadow: "0 4px 24px rgba(0,0,0,0.06)",
                border: "1px solid rgba(0,0,0,0.06)",
                transition: "all 0.3s ease",
                position: "relative",
                overflow: "hidden",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-6px)";
                e.currentTarget.style.boxShadow = `0 20px 40px ${feature.color}20`;
                e.currentTarget.style.borderColor = `${feature.color}40`;
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow = "0 4px 24px rgba(0,0,0,0.06)";
                e.currentTarget.style.borderColor = "rgba(0,0,0,0.06)";
              }}
            >
              {/* Decorativo de fundo */}
              <div style={{
                position: "absolute",
                top: "-40px",
                right: "-40px",
                width: "150px",
                height: "150px",
                background: feature.bgLight,
                borderRadius: "50%",
                opacity: 0.6,
                pointerEvents: "none",
              }} />

              {/* Header do card */}
              <div style={{ display: "flex", alignItems: "flex-start", gap: "16px", marginBottom: "20px", position: "relative" }}>
                <div style={{
                  width: "56px",
                  height: "56px",
                  borderRadius: "14px",
                  background: feature.gradient,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "#fff",
                  boxShadow: `0 8px 20px ${feature.color}40`,
                  flexShrink: 0,
                }}>
                  <feature.icon />
                </div>
                <div>
                  <h3 style={{ 
                    fontSize: "1.25rem", 
                    fontWeight: 700, 
                    marginBottom: "6px",
                    color: "#1f2937",
                  }}>
                    {feature.title}
                  </h3>
                  <p style={{ 
                    fontSize: "0.9rem", 
                    color: "#6b7280",
                    margin: 0,
                    lineHeight: 1.5,
                  }}>
                    {feature.description}
                  </p>
                </div>
              </div>

              {/* Lista de bullets */}
              <div style={{
                display: "grid",
                gridTemplateColumns: "repeat(2, 1fr)",
                gap: "10px",
                position: "relative",
              }}>
                {feature.bullets.map((bullet, i) => (
                  <div 
                    key={i} 
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                      padding: "10px 12px",
                      background: feature.bgLight,
                      borderRadius: "10px",
                      transition: "all 0.2s ease",
                    }}
                  >
                    <div style={{
                      width: "18px",
                      height: "18px",
                      borderRadius: "50%",
                      background: feature.gradient,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexShrink: 0,
                    }}>
                      <Icons.Check />
                    </div>
                    <span style={{ 
                      fontSize: "0.8rem", 
                      fontWeight: 500, 
                      color: "#374151",
                    }}>
                      {bullet}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>

      <style>{`
        @media (max-width: 900px) {
          .features-grid {
            grid-template-columns: 1fr !important;
          }
        }
      `}</style>
    </section>
  );
}

// Extras Section - Softphone e Chat Interno
function ExtrasSection() {
  const extras = [
    {
      ...t.extras.softphone,
      icon: Icons.Phone,
      color: "#865ceb", // Purple
      gradient: "linear-gradient(135deg, #9f82ec, #865ceb)",
      emoji: "📞",
    },
    {
      ...t.extras.chatInternal,
      icon: Icons.MessageSquare,
      color: "#ff9b17", // Orange
      gradient: "linear-gradient(135deg, #ff9b17, #f77c02)",
      emoji: "💬",
    },
    {
      ...t.extras.googleDrive,
      icon: Icons.Database,
      color: "#0070F3", // Blue
      gradient: "linear-gradient(135deg, #3B82F6, #0070F3)",
      emoji: "☁️",
    },
  ];

  return (
    <section className="landing-section" style={{
      background: "linear-gradient(135deg, #fdfdfc 0%, #dedad5 50%, #fdfdfc 100%)",
      padding: "100px 0",
    }}>
      <div className="landing-container">
        <div className="landing-section-header" style={{ marginBottom: "60px" }}>
          <div style={{
            display: "inline-flex",
            alignItems: "center",
            gap: "8px",
            background: "linear-gradient(135deg, rgba(134,92,235,0.15) 0%, rgba(255,155,23,0.15) 100%)",
            padding: "8px 16px",
            borderRadius: "100px",
            marginBottom: "16px",
          }}>
            <span style={{ fontSize: "1rem" }}>⭐</span>
            <span style={{ fontSize: "0.875rem", fontWeight: 600, color: "#865ceb" }}>Exclusivo OmniPlay</span>
          </div>
          <h2>{t.extras.title}</h2>
          <p>{t.extras.subtitle}</p>
        </div>

        <div style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
          gap: "32px",
          maxWidth: "1100px",
          margin: "0 auto",
        }} className="extras-grid">
          {extras.map((extra, index) => (
            <div 
              key={index}
              style={{
                background: "#fff",
                borderRadius: "24px",
                padding: "40px",
                boxShadow: "0 10px 40px rgba(0,0,0,0.08)",
                border: `2px solid ${extra.color}20`,
                position: "relative",
                overflow: "hidden",
                transition: "all 0.3s ease",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-8px)";
                e.currentTarget.style.boxShadow = `0 20px 60px ${extra.color}25`;
                e.currentTarget.style.borderColor = `${extra.color}50`;
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow = "0 10px 40px rgba(0,0,0,0.08)";
                e.currentTarget.style.borderColor = `${extra.color}20`;
              }}
            >
              {/* Background decorativo */}
              <div style={{
                position: "absolute",
                top: "-60px",
                right: "-60px",
                width: "200px",
                height: "200px",
                background: `${extra.color}10`,
                borderRadius: "50%",
                pointerEvents: "none",
              }} />
              
              {/* Badge TOP */}
              <div style={{
                position: "absolute",
                top: "20px",
                right: "20px",
                background: extra.gradient,
                color: "#fff",
                fontSize: "0.7rem",
                fontWeight: 700,
                padding: "6px 12px",
                borderRadius: "100px",
                textTransform: "uppercase",
                letterSpacing: "0.5px",
                boxShadow: `0 4px 12px ${extra.color}40`,
              }}>
                ⭐ Top Feature
              </div>

              {/* Header */}
              <div style={{ marginBottom: "24px", position: "relative" }}>
                <div style={{
                  width: "72px",
                  height: "72px",
                  borderRadius: "20px",
                  background: extra.gradient,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginBottom: "20px",
                  boxShadow: `0 12px 30px ${extra.color}40`,
                  fontSize: "2rem",
                }}>
                  {extra.emoji}
                </div>
                <h3 style={{
                  fontSize: "1.5rem",
                  fontWeight: 700,
                  color: "#1f2937",
                  marginBottom: "12px",
                }}>
                  {extra.title}
                </h3>
                <p style={{
                  fontSize: "1rem",
                  color: "#6b7280",
                  lineHeight: 1.6,
                  margin: 0,
                }}>
                  {extra.description}
                </p>
              </div>

              {/* Features list */}
              <div style={{
                display: "flex",
                flexDirection: "column",
                gap: "12px",
              }}>
                {extra.features.map((feature, i) => (
                  <div 
                    key={i}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "12px",
                      padding: "12px 16px",
                      background: `${extra.color}08`,
                      borderRadius: "12px",
                      borderLeft: `3px solid ${extra.color}`,
                    }}
                  >
                    <div style={{
                      width: "22px",
                      height: "22px",
                      borderRadius: "50%",
                      background: extra.gradient,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexShrink: 0,
                      color: "#fff",
                    }}>
                      <Icons.Check />
                    </div>
                    <span style={{
                      fontSize: "0.9rem",
                      fontWeight: 500,
                      color: "#374151",
                    }}>
                      {feature}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>

      <style>{`
        @media (max-width: 768px) {
          .extras-grid {
            grid-template-columns: 1fr !important;
          }
        }
      `}</style>
    </section>
  );
}

// Screenshots Section
function ScreenshotsSection() {
  return (
    <section className="landing-section">
      <div className="landing-container">
        <div className="landing-section-header">
          <h2>{t.screenshots.title}</h2>
          <p>{t.screenshots.subtitle}</p>
        </div>

        <Swiper
          effect={'coverflow'}
          grabCursor={true}
          centeredSlides={true}
          slidesPerView={'auto'}
          coverflowEffect={{
            rotate: 50,
            stretch: 0,
            depth: 100,
            modifier: 1,
            slideShadows: true,
          }}
          pagination={true}
          autoplay={{
            delay: 3500,
            disableOnInteraction: false,
          }}
          loop={true}
          modules={[EffectCoverflow, Pagination, Autoplay]}
          className="landing-swiper"
        >
          {screenshotsList.map((item, index) => (
            <SwiperSlide key={index}>
              <div className="landing-carousel-content">
                <div className="landing-carousel-image-container">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="landing-carousel-image"
                  />
                </div>
                <div className="landing-carousel-caption">
                  <h4>{item.title}</h4>
                  <p>{item.description}</p>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
}

// Pricing Section
function PricingSection({ scrollToSection, history }) {
  return (
    <section className="landing-section" id="pricing">
      <div className="landing-container">
        <div className="landing-section-header">
          <h2>{t.pricing.title}</h2>
          <p>{t.pricing.subtitle}</p>
        </div>
        
        {/* CTA para página de preços */}
        <div style={{ 
          textAlign: "center", 
          padding: "60px 20px",
          background: "linear-gradient(135deg, #fdfdfc 0%, #dedad4 100%)",
          borderRadius: 24,
          maxWidth: 800,
          margin: "0 auto",
          boxShadow: "0 10px 40px rgba(0,0,0,0.05)"
        }}>
          <div style={{ marginBottom: 24, fontSize: 48 }}>
            🚀
          </div>
          <h3 style={{ 
            fontSize: "1.8rem", 
            fontWeight: 700, 
            color: "#2d3436",
            marginBottom: 16 
          }}>
            Planos para todos os tamanhos de negócio
          </h3>
          <p style={{ 
            fontSize: "1.1rem", 
            color: "#636e72",
            marginBottom: 32,
            maxWidth: 500,
            margin: "0 auto 32px"
          }}>
            Comece com 7 dias grátis. Escolha o plano ideal para sua empresa com preços transparentes e sem surpresas.
          </p>
          <div style={{ display: "flex", gap: 16, justifyContent: "center", flexWrap: "wrap" }}>
            <button
              className="landing-btn-primary"
              onClick={() => history.push("/pricing")}
              style={{ padding: "14px 32px", fontSize: "1.1rem" }}
            >
              Ver Planos e Preços
              <Icons.ArrowRight />
            </button>
          </div>
          <p style={{ 
            marginTop: 24, 
            fontSize: "0.9rem", 
            color: "#9ca3af" 
          }}>
            ✓ Sem cartão de crédito &nbsp;&nbsp; ✓ Cancele quando quiser &nbsp;&nbsp; ✓ Suporte incluído
          </p>
        </div>
      </div>
    </section>
  );
}

// FAQ Section
function FAQSection() {
  const [openItems, setOpenItems] = useState({});
  const [activeCategory, setActiveCategory] = useState(0);

  const toggleItem = (categoryIndex, itemIndex) => {
    const key = `${categoryIndex}-${itemIndex}`;
    setOpenItems(prev => ({
      ...prev,
      [key]: !prev[key]
    }));
  };

  const categoryColors = ["#865ceb", "#ff9b17", "#ff609a", "#f5d444", "#865ceb"];

  return (
    <section className="landing-section" id="faq" style={{
      background: "linear-gradient(180deg, #fdfdfc 0%, #ffffff 100%)",
      padding: "100px 0",
    }}>
      <div className="landing-container">
        <div className="landing-section-header" style={{ marginBottom: "48px" }}>
          <div style={{
            display: "inline-flex",
            alignItems: "center",
            gap: "8px",
            background: "rgba(134, 92, 235, 0.1)",
            padding: "8px 16px",
            borderRadius: "100px",
            marginBottom: "16px",
          }}>
            <span style={{ fontSize: "1rem" }}>❓</span>
            <span style={{ fontSize: "0.875rem", fontWeight: 600, color: "#865ceb" }}>Tire suas dúvidas</span>
          </div>
          <h2>{t.faq.title}</h2>
          <p>{t.faq.subtitle}</p>
        </div>

        {/* Tabs de categorias */}
        <div style={{
          display: "flex",
          flexWrap: "wrap",
          gap: "12px",
          justifyContent: "center",
          marginBottom: "40px",
        }}>
          {t.faq.categories.map((category, index) => (
            <button
              key={index}
              onClick={() => setActiveCategory(index)}
              style={{
                padding: "12px 20px",
                borderRadius: "100px",
                border: activeCategory === index ? "none" : "1px solid #e5e7eb",
                background: activeCategory === index 
                  ? categoryColors[index % categoryColors.length]
                  : "#fff",
                color: activeCategory === index ? "#fff" : "#6b7280",
                fontSize: "0.9rem",
                fontWeight: 600,
                cursor: "pointer",
                transition: "all 0.2s ease",
                boxShadow: activeCategory === index 
                  ? `0 4px 12px ${categoryColors[index % categoryColors.length]}40`
                  : "0 2px 8px rgba(0,0,0,0.05)",
              }}
            >
              {category.name}
            </button>
          ))}
        </div>

        {/* FAQ Items da categoria ativa */}
        <div style={{
          maxWidth: "900px",
          margin: "0 auto",
        }}>
          {t.faq.categories[activeCategory].items.map((item, itemIndex) => {
            const isOpen = openItems[`${activeCategory}-${itemIndex}`];
            const color = categoryColors[activeCategory % categoryColors.length];
            
            return (
              <div 
                key={itemIndex}
                style={{
                  marginBottom: "12px",
                  background: "#fff",
                  borderRadius: "16px",
                  border: isOpen ? `2px solid ${color}40` : "1px solid #e5e7eb",
                  overflow: "hidden",
                  transition: "all 0.2s ease",
                  boxShadow: isOpen ? `0 8px 24px ${color}15` : "0 2px 8px rgba(0,0,0,0.04)",
                }}
              >
                <button
                  onClick={() => toggleItem(activeCategory, itemIndex)}
                  style={{
                    width: "100%",
                    padding: "20px 24px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    background: "none",
                    border: "none",
                    cursor: "pointer",
                    textAlign: "left",
                  }}
                >
                  <span style={{
                    fontSize: "1rem",
                    fontWeight: 600,
                    color: isOpen ? color : "#1f2937",
                    paddingRight: "16px",
                  }}>
                    {item.question}
                  </span>
                  <div style={{
                    width: "28px",
                    height: "28px",
                    borderRadius: "50%",
                    background: isOpen ? color : "#f3f4f6",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexShrink: 0,
                    transition: "all 0.2s ease",
                    transform: isOpen ? "rotate(180deg)" : "rotate(0deg)",
                    color: isOpen ? "#fff" : "#9ca3af",
                  }}>
                    <Icons.ChevronDown />
                  </div>
                </button>
                
                {isOpen && (
                  <div style={{
                    padding: "0 24px 20px 24px",
                    borderTop: `1px solid ${color}20`,
                  }}>
                    <p style={{
                      fontSize: "0.95rem",
                      color: "#6b7280",
                      lineHeight: 1.7,
                      margin: "16px 0 0 0",
                    }}>
                      {item.answer}
                    </p>
                  </div>
                )}
              </div>
            );
          })}
        </div>

      </div>
    </section>
  );
}

// Contact Section
function ContactSection() {
  const [formData, setFormData] = useState({ name: "", email: "", company: "", message: "" });
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Número do WhatsApp para contato (com código do país)
  const WHATSAPP_NUMBER = "5518997751073";

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    // Montar mensagem formatada para WhatsApp
    // Usar %0A para quebras de linha (funciona melhor na URL do WhatsApp)
    const linhas = [
      "*Novo contato via OmniPlay*",
      "",
      `*Nome:* ${formData.name}`,
      `*Email:* ${formData.email}`,
      `*Empresa:* ${formData.company}`,
      "",
      "*Mensagem:*",
      formData.message,
      "",
      "---",
      "_Enviado pelo formulário de contato do site_"
    ];
    
    // Codificar cada linha e juntar com %0A (quebra de linha URL-encoded)
    const mensagemCodificada = linhas
      .map(linha => encodeURIComponent(linha))
      .join("%0A");
    
    // Abrir WhatsApp com a mensagem
    const whatsappUrl = `https://wa.me/${WHATSAPP_NUMBER}?text=${mensagemCodificada}`;
    
    // Pequeno delay para feedback visual
    await new Promise((resolve) => setTimeout(resolve, 300));
    
    // Abrir em nova aba
    window.open(whatsappUrl, "_blank");
    
    setIsSubmitting(false);
    setFormData({ name: "", email: "", company: "", message: "" });
  };

  return (
    <section className="landing-section" id="contact">
      <div className="landing-container">
        <div className="landing-contact-grid">
          <div className="landing-contact-info">
            <h2>{t.contact.title}</h2>
            <p>{t.contact.subtitle}</p>
            <div className="landing-contact-items">
              <div className="landing-contact-item">
                <div className="landing-contact-item-icon">
                  <Icons.Mail />
                </div>
                <div>
                  <strong>{t.contact.info.emailLabel}</strong>
                  <span>{t.contact.info.email}</span>
                </div>
              </div>
              <div className="landing-contact-item">
                <div className="landing-contact-item-icon">
                  <Icons.Phone />
                </div>
                <div>
                  <strong>{t.contact.info.phoneLabel}</strong>
                  <span>{t.contact.info.phone}</span>
                </div>
              </div>
              <div className="landing-contact-item">
                <div className="landing-contact-item-icon">
                  <Icons.Clock />
                </div>
                <div>
                  <strong>{t.contact.info.hours}</strong>
                  <span>{t.contact.info.address}</span>
                </div>
              </div>
            </div>
            <div className="landing-contact-social">
              <p>{t.contact.social}</p>
              <div className="landing-contact-social-icons">
                <a
                  href="https://wa.me/5518997751073"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="landing-btn-icon"
                >
                  <Icons.WhatsApp />
                </a>
              </div>
            </div>
          </div>
          <div className="landing-contact-form-wrapper">
            <form className="landing-contact-form" onSubmit={handleSubmit}>
              <input
                type="text"
                placeholder={t.contact.form.name}
                value={formData.name}
                onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                required
              />
              <input
                type="email"
                placeholder={t.contact.form.email}
                value={formData.email}
                onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                required
              />
              <input
                type="text"
                placeholder={t.contact.form.company}
                value={formData.company}
                onChange={(e) => setFormData({ ...formData, company: e.target.value })}
                required
              />
              <textarea
                placeholder={t.contact.form.message}
                value={formData.message}
                onChange={(e) => setFormData({ ...formData, message: e.target.value })}
                required
                rows={4}
              />
              <button type="submit" className="landing-btn-primary full-width" disabled={isSubmitting}>
                {isSubmitting ? t.contact.form.sending : "Enviar via WhatsApp"}
                <Icons.WhatsApp />
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}

// Footer
function Footer() {
  return (
    <footer className="landing-footer">
      <div className="landing-container">
        <div className="landing-footer-grid">
          <div className="landing-footer-brand">
            <div className="landing-nav-logo">
              <img src={omniplayLogo} alt="OmniPlay" />
            </div>
            <p>{t.footer.description}</p>
          </div>
          <div className="landing-footer-links">
            <h4>{t.footer.product}</h4>
            <a href="#features">{t.footer.links.features}</a>
            <a href="#pricing">{t.footer.links.pricing}</a>
          </div>
          <div className="landing-footer-links">
            <h4>{t.footer.legal}</h4>
            <a href="/legal/politica-de-privacidade.html" target="_blank" rel="noopener noreferrer">
              {t.footer.links.privacy}
            </a>
            <a href="/legal/termos-de-uso.html" target="_blank" rel="noopener noreferrer">
              {t.footer.links.terms}
            </a>
            <a href="/legal/exclusao-de-dados.html" target="_blank" rel="noopener noreferrer">
              Exclusão de Dados
            </a>
          </div>
        </div>
        <div className="landing-footer-bottom">
          <p>© {new Date().getFullYear()} OmniPlay. {t.footer.copyright}</p>
          <div className="landing-footer-social">
            <a
              href="https://wa.me/5518997751073"
              target="_blank"
              rel="noopener noreferrer"
              className="landing-btn-icon-ghost"
            >
              <Icons.WhatsApp />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}

// Main Landing Component
const Landing = () => {
  const history = useHistory();
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <div className="landing-page">
      <Navigation
        isScrolled={isScrolled}
        isMobileMenuOpen={isMobileMenuOpen}
        setIsMobileMenuOpen={setIsMobileMenuOpen}
        scrollToSection={scrollToSection}
        history={history}
      />
      <HeroSection scrollToSection={scrollToSection} history={history} />
      <ChannelsSection />
      <TalkAISection />
      <ValuePropsSection />
      <FeaturesShowcase />
      <ExtrasSection />
      <ScreenshotsSection />
      <PricingSection scrollToSection={scrollToSection} history={history} />
      <FAQSection />
      <ContactSection />
      <Footer />
    </div>
  );
};

export default Landing;
